<div class="step-shell">
  <div class="step-header">
    <h2>{{ 'profile.taxDocumentation' | translate }}</h2>
    <p class="step-subtitle">
      <a class="tax-form-name-link" [href]="originalFormUrl" target="_blank" rel="noopener noreferrer">
        {{ formNameKey | translate }}
      </a>
      {{ residencySuffixKey | translate }}
    </p>
  </div>

  <div class="certification-copy">
    @if (isFullCertificationVisible()) {
      <div class="certification-copy__text-scroll certification-copy__text-scroll--full">
        <div class="certification-copy__expanded certification-copy__expanded--w8ben">
          <p>{{ 'profile.w8BenCertificationExpandedIntro' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph1' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph2' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph3' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph4' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph5' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph6' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph7' | translate }}</p>
          <p>{{ 'profile.w8BenCertificationParagraph8' | translate }}</p>
          <div class="certification-copy__paragraph-spacer" aria-hidden="true"></div>
          <p>
            {{ 'profile.w8BenCertificationParagraph9a' | translate }}
            {{ 'profile.w8BenCertificationParagraph9b' | translate }}
            {{ 'profile.w8BenCertificationParagraph9c' | translate }}
            {{ 'profile.w8BenCertificationParagraph9d' | translate }}
            {{ 'profile.w8BenCertificationParagraph9e' | translate }}
            {{ 'profile.w8BenCertificationParagraph9f' | translate }}
          </p>
        </div>
      </div>

      <p class="certification-copy__warning">{{ 'profile.w8BenTreatyBenefitsDisclaimer' | translate }}</p>
    } @else {
      <p>
        {{ 'profile.w8BenCertificationShortIntro' | translate }}
        <button type="button" class="certification-copy__link-button" (click)="showFullCertification()">
          {{ 'profile.viewFullCertification' | translate }}
        </button>
      </p>
    }

    <div class="certification-card">
      <label class="checkbox-row checkbox-row--compact">
        <input type="checkbox" [formControl]="iCertifyControl()" />
        <span>{{ 'profile.electronicSignatureCetifif' | translate }}</span>
      </label>

      <p>
        {{ (isFullCertificationVisible() ? 'profile.iCertify' : 'profile.w9CertificationAgreement') | translate }}
      </p>
      <p>{{ 'profile.date' | translate }} {{ today() }}</p>
    </div>

    <korviu-input [label]="'profile.w8BenPrintNameOfSigner' | translate" size="large" [control]="signerNameControl()" />

    <p class="certification-copy__disclaimer">{{ 'profile.taxAdviceDisclaimer' | translate }}</p>
  </div>
</div>
